import CreateInvestmentError from './CreateInvestmentError';
class InvestorExceededLimits extends CreateInvestmentError {
    constructor(options) {
        super('Investor exceeded allowed account level limits', options);
    }
}
export default InvestorExceededLimits;
